/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Below Code is Open external Link in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  const patientsPage = document.querySelectorAll(".redirect_pateints_page");
  patientsPage.forEach((p) => {
    p.addEventListener("click", () => {
      const domain = window.location.origin;
      const pageUrl = `${domain}/pages/patients`;
      const pageContacts = `${domain}/pages/contactus-patients`;
      const pageAll = `${domain}/collections/patients`;
      if (window.location.href !== pageUrl && window.location.href !== pageContacts && window.location.href !== pageAll) {
        window.location.href = pageUrl;
      }
    });
  });
})();
